import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  templateUrl: 'html-wrapper.component.html',
  styleUrls: ['html-wrapper.component.scss'],
})
export class HtmlWrapperComponent extends FieldWrapper {
}
